var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 116,
    viewBox: "0 0 277 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11513_7906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H269C273.418 0 277 3.58172 277 8V116H0V8Z",
    fill: "url(#paint0_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_11513_7906)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 61,
    cy: 90,
    rx: 37,
    ry: 31,
    fill: "#E0ECF9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_11513_7906)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 210,
    cy: 53,
    rx: 37,
    ry: 31,
    fill: "#E0ECF9",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.554016,
    y: -0.511719,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint1_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.9055,
    y: -0.511719,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint2_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2568,
    y: -0.511719,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint3_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6083,
    y: -0.511719,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint4_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.9597,
    y: -0.511719,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint5_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.3109,
    y: -0.511719,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint6_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.662,
    y: -0.511719,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint7_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.554016,
    y: 8.44531,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint8_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.9055,
    y: 8.44531,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint9_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2568,
    y: 8.44531,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint10_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6083,
    y: 8.44531,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint11_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.9597,
    y: 8.44531,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint12_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.3109,
    y: 8.44531,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint13_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.662,
    y: 8.44531,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint14_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.554016,
    y: 17.4033,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint15_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.9055,
    y: 17.4033,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint16_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2568,
    y: 17.4033,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint17_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6083,
    y: 17.4033,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint18_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.9597,
    y: 17.4033,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint19_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.3109,
    y: 17.4033,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint20_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.662,
    y: 17.4033,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint21_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.554016,
    y: 26.3604,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint22_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.9055,
    y: 26.3604,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint23_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2568,
    y: 26.3604,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint24_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6083,
    y: 26.3604,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint25_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.9597,
    y: 26.3604,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint26_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.3109,
    y: 26.3604,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint27_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.662,
    y: 26.3604,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint28_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.554016,
    y: 35.3184,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint29_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.9055,
    y: 35.3184,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint30_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2568,
    y: 35.3184,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint31_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6083,
    y: 35.3184,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint32_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.9597,
    y: 35.3184,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint33_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.3109,
    y: 35.3184,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint34_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.662,
    y: 35.3184,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint35_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.554016,
    y: 44.2754,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint36_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.554016,
    y: 52.915,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint37_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.554016,
    y: 61.5537,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint38_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.554016,
    y: 70.1934,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint39_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.9055,
    y: 44.2754,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint40_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.9055,
    y: 52.915,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint41_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.9055,
    y: 61.5537,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint42_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.9055,
    y: 70.1934,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint43_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2568,
    y: 44.2754,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint44_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2568,
    y: 52.915,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint45_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2568,
    y: 61.5537,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint46_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.2568,
    y: 70.1934,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint47_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6083,
    y: 44.2754,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint48_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6083,
    y: 52.915,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint49_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6083,
    y: 61.5537,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint50_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6083,
    y: 70.1934,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint51_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.9597,
    y: 44.2754,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint52_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.9597,
    y: 52.915,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint53_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.9597,
    y: 61.5537,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint54_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.9597,
    y: 70.1934,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint55_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.3109,
    y: 44.2754,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint56_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.3109,
    y: 52.915,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint57_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.3109,
    y: 61.5537,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint58_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.3109,
    y: 70.1934,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint59_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.662,
    y: 44.2754,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint60_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.662,
    y: 52.915,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint61_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.662,
    y: 61.5537,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint62_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.662,
    y: 70.1934,
    width: 2.83784,
    height: 2.23938,
    rx: 1.11969,
    fill: "url(#paint63_linear_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.85,
    y: 34.85,
    width: 185.3,
    height: 99.3,
    rx: 4.15,
    stroke: "#F6F6F9",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-68-inside-1_11513_7906",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 39C45 36.7909 46.7909 35 49 35H226C228.209 35 230 36.7909 230 39V44H45V39Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45 39C45 36.7909 46.7909 35 49 35H226C228.209 35 230 36.7909 230 39V44H45V39Z",
    fill: "#FAFBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 35H230H45ZM230 44.3H45V43.7H230V44.3ZM45 44V35V44ZM230 35V44V35Z",
    fill: "#EAEAEF",
    mask: "url(#path-68-inside-1_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 38,
    width: 25,
    height: 3,
    rx: 1.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 38,
    width: 33,
    height: 3,
    rx: 1.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-72-inside-2_11513_7906",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 44H230V59H45V44Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45 44H230V59H45V44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 58.7H45V59.3H230V58.7Z",
    fill: "#EAEAEF",
    mask: "url(#path-72-inside-2_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 47,
    width: 25,
    height: 3,
    rx: 1.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 49,
    width: 17,
    height: 3,
    rx: 1.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 50,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 52,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 47,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#F5F9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 46,
    width: 6,
    height: 4,
    rx: 1,
    fill: "#FFE9DF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-80-inside-3_11513_7906",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 59H230V74H45V59Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45 59H230V74H45V59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 73.7H45V74.3H230V73.7Z",
    fill: "#EAEAEF",
    mask: "url(#path-80-inside-3_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 62,
    width: 41,
    height: 3,
    rx: 1.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 64,
    width: 17,
    height: 3,
    rx: 1.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 65,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 67,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 62,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#F5F9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 61,
    width: 6,
    height: 4,
    rx: 1,
    fill: "#E7FFDF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-88-inside-4_11513_7906",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 74H230V89H45V74Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45 74H230V89H45V74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 88.7H45V89.3H230V88.7Z",
    fill: "#EAEAEF",
    mask: "url(#path-88-inside-4_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 77,
    width: 31,
    height: 3,
    rx: 1.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 79,
    width: 17,
    height: 3,
    rx: 1.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 80,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 82,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 77,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#F5F9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 76,
    width: 6,
    height: 4,
    rx: 1,
    fill: "#FFE9DF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-96-inside-5_11513_7906",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 89H230V104H45V89Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45 89H230V104H45V89Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 103.7H45V104.3H230V103.7Z",
    fill: "#EAEAEF",
    mask: "url(#path-96-inside-5_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 92,
    width: 41,
    height: 3,
    rx: 1.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 94,
    width: 17,
    height: 3,
    rx: 1.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 95,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 97,
    width: 28,
    height: 3,
    rx: 1.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 92,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#F5F9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 91,
    width: 6,
    height: 4,
    rx: 1,
    fill: "#FFE9DF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-104-inside-6_11513_7906",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 104H230V119H45V104Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45 104H230V119H45V104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 118.7H45V119.3H230V118.7Z",
    fill: "#EAEAEF",
    mask: "url(#path-104-inside-6_11513_7906)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 107,
    width: 25,
    height: 3,
    rx: 1.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 109,
    width: 17,
    height: 3,
    rx: 1.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 110,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 112,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 107,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#F5F9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 106,
    width: 6,
    height: 4,
    rx: 1,
    fill: "#FFE9DF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 68,
    width: 276,
    height: 47,
    fill: "url(#paint64_linear_11513_7906)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_11513_7906",
    x: 4,
    y: 39,
    width: 114,
    height: 102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_11513_7906"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_11513_7906",
    x: 143,
    y: -8,
    width: 134,
    height: 122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_11513_7906"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11513_7906",
    x1: 138.5,
    y1: 0,
    x2: 138.5,
    y2: 145.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11513_7906",
    x1: 1.97294,
    y1: -0.511719,
    x2: 1.97294,
    y2: 1.72766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11513_7906",
    x1: 13.3244,
    y1: -0.511719,
    x2: 13.3244,
    y2: 1.72766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11513_7906",
    x1: 24.6758,
    y1: -0.511719,
    x2: 24.6758,
    y2: 1.72766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11513_7906",
    x1: 36.0272,
    y1: -0.511719,
    x2: 36.0272,
    y2: 1.72766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11513_7906",
    x1: 47.3786,
    y1: -0.511719,
    x2: 47.3786,
    y2: 1.72766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11513_7906",
    x1: 58.7298,
    y1: -0.511719,
    x2: 58.7298,
    y2: 1.72766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11513_7906",
    x1: 70.081,
    y1: -0.511719,
    x2: 70.081,
    y2: 1.72766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_11513_7906",
    x1: 1.97294,
    y1: 8.44531,
    x2: 1.97294,
    y2: 10.6847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_11513_7906",
    x1: 13.3244,
    y1: 8.44531,
    x2: 13.3244,
    y2: 10.6847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_11513_7906",
    x1: 24.6758,
    y1: 8.44531,
    x2: 24.6758,
    y2: 10.6847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_11513_7906",
    x1: 36.0272,
    y1: 8.44531,
    x2: 36.0272,
    y2: 10.6847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_11513_7906",
    x1: 47.3786,
    y1: 8.44531,
    x2: 47.3786,
    y2: 10.6847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_11513_7906",
    x1: 58.7298,
    y1: 8.44531,
    x2: 58.7298,
    y2: 10.6847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_11513_7906",
    x1: 70.081,
    y1: 8.44531,
    x2: 70.081,
    y2: 10.6847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_11513_7906",
    x1: 1.97294,
    y1: 17.4033,
    x2: 1.97294,
    y2: 19.6427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_11513_7906",
    x1: 13.3244,
    y1: 17.4033,
    x2: 13.3244,
    y2: 19.6427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_11513_7906",
    x1: 24.6758,
    y1: 17.4033,
    x2: 24.6758,
    y2: 19.6427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_11513_7906",
    x1: 36.0272,
    y1: 17.4033,
    x2: 36.0272,
    y2: 19.6427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_11513_7906",
    x1: 47.3786,
    y1: 17.4033,
    x2: 47.3786,
    y2: 19.6427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_11513_7906",
    x1: 58.7298,
    y1: 17.4033,
    x2: 58.7298,
    y2: 19.6427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_11513_7906",
    x1: 70.081,
    y1: 17.4033,
    x2: 70.081,
    y2: 19.6427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_11513_7906",
    x1: 1.97294,
    y1: 26.3604,
    x2: 1.97294,
    y2: 28.5997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_11513_7906",
    x1: 13.3244,
    y1: 26.3604,
    x2: 13.3244,
    y2: 28.5997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_11513_7906",
    x1: 24.6758,
    y1: 26.3604,
    x2: 24.6758,
    y2: 28.5997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_11513_7906",
    x1: 36.0272,
    y1: 26.3604,
    x2: 36.0272,
    y2: 28.5997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_11513_7906",
    x1: 47.3786,
    y1: 26.3604,
    x2: 47.3786,
    y2: 28.5997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_11513_7906",
    x1: 58.7298,
    y1: 26.3604,
    x2: 58.7298,
    y2: 28.5997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_11513_7906",
    x1: 70.081,
    y1: 26.3604,
    x2: 70.081,
    y2: 28.5997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_11513_7906",
    x1: 1.97294,
    y1: 35.3184,
    x2: 1.97294,
    y2: 37.5577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_11513_7906",
    x1: 13.3244,
    y1: 35.3184,
    x2: 13.3244,
    y2: 37.5577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_11513_7906",
    x1: 24.6758,
    y1: 35.3184,
    x2: 24.6758,
    y2: 37.5577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_11513_7906",
    x1: 36.0272,
    y1: 35.3184,
    x2: 36.0272,
    y2: 37.5577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_11513_7906",
    x1: 47.3786,
    y1: 35.3184,
    x2: 47.3786,
    y2: 37.5577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_11513_7906",
    x1: 58.7298,
    y1: 35.3184,
    x2: 58.7298,
    y2: 37.5577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_11513_7906",
    x1: 70.081,
    y1: 35.3184,
    x2: 70.081,
    y2: 37.5577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_11513_7906",
    x1: 1.97294,
    y1: 44.2754,
    x2: 1.97294,
    y2: 46.5148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_11513_7906",
    x1: 1.97294,
    y1: 52.915,
    x2: 1.97294,
    y2: 55.1544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_11513_7906",
    x1: 1.97294,
    y1: 61.5537,
    x2: 1.97294,
    y2: 63.7931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_11513_7906",
    x1: 1.97294,
    y1: 70.1934,
    x2: 1.97294,
    y2: 72.4327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_11513_7906",
    x1: 13.3244,
    y1: 44.2754,
    x2: 13.3244,
    y2: 46.5148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_11513_7906",
    x1: 13.3244,
    y1: 52.915,
    x2: 13.3244,
    y2: 55.1544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_11513_7906",
    x1: 13.3244,
    y1: 61.5537,
    x2: 13.3244,
    y2: 63.7931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_11513_7906",
    x1: 13.3244,
    y1: 70.1934,
    x2: 13.3244,
    y2: 72.4327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_11513_7906",
    x1: 24.6758,
    y1: 44.2754,
    x2: 24.6758,
    y2: 46.5148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_11513_7906",
    x1: 24.6758,
    y1: 52.915,
    x2: 24.6758,
    y2: 55.1544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_11513_7906",
    x1: 24.6758,
    y1: 61.5537,
    x2: 24.6758,
    y2: 63.7931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_11513_7906",
    x1: 24.6758,
    y1: 70.1934,
    x2: 24.6758,
    y2: 72.4327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_11513_7906",
    x1: 36.0272,
    y1: 44.2754,
    x2: 36.0272,
    y2: 46.5148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_11513_7906",
    x1: 36.0272,
    y1: 52.915,
    x2: 36.0272,
    y2: 55.1544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_11513_7906",
    x1: 36.0272,
    y1: 61.5537,
    x2: 36.0272,
    y2: 63.7931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_11513_7906",
    x1: 36.0272,
    y1: 70.1934,
    x2: 36.0272,
    y2: 72.4327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_11513_7906",
    x1: 47.3786,
    y1: 44.2754,
    x2: 47.3786,
    y2: 46.5148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_11513_7906",
    x1: 47.3786,
    y1: 52.915,
    x2: 47.3786,
    y2: 55.1544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_11513_7906",
    x1: 47.3786,
    y1: 61.5537,
    x2: 47.3786,
    y2: 63.7931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_11513_7906",
    x1: 47.3786,
    y1: 70.1934,
    x2: 47.3786,
    y2: 72.4327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_11513_7906",
    x1: 58.7298,
    y1: 44.2754,
    x2: 58.7298,
    y2: 46.5148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_11513_7906",
    x1: 58.7298,
    y1: 52.915,
    x2: 58.7298,
    y2: 55.1544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_11513_7906",
    x1: 58.7298,
    y1: 61.5537,
    x2: 58.7298,
    y2: 63.7931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_11513_7906",
    x1: 58.7298,
    y1: 70.1934,
    x2: 58.7298,
    y2: 72.4327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_11513_7906",
    x1: 70.081,
    y1: 44.2754,
    x2: 70.081,
    y2: 46.5148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_11513_7906",
    x1: 70.081,
    y1: 52.915,
    x2: 70.081,
    y2: 55.1544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_11513_7906",
    x1: 70.081,
    y1: 61.5537,
    x2: 70.081,
    y2: 63.7931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_11513_7906",
    x1: 70.081,
    y1: 70.1934,
    x2: 70.081,
    y2: 72.4327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_11513_7906",
    x1: 147,
    y1: 68,
    x2: 147,
    y2: 115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11513_7906"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H269C273.418 0 277 3.58172 277 8V116H0V8Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyData);
export default __webpack_public_path__ + "static/media/empty-data.6cf6aa56e1b534b7d04ce913a71c0d2b.svg";
export { ForwardRef as ReactComponent };